/**
 * LazyTiptapEditor
 *
 * Code-split entry point for the rich-text {@link TiptapEditor}. The Tiptap /
 * ProseMirror bundle is heavy, so every consumer (note detail, note form, the
 * public read-only note body) loads it lazily behind a `<Suspense>` boundary.
 * Sharing a single `lazy()` call keeps the editor in one chunk and avoids the
 * three duplicate definitions that previously drifted apart.
 *
 * @module components/notes/editor/LazyTiptapEditor
 */
import { lazy } from 'react';

export const LazyTiptapEditor = lazy(() =>
  import('./TiptapEditor').then((module) => ({
    default: module.TiptapEditor,
  }))
);
